export const get = async (url: string, dataHandler: Function | null) => {
    let getLoading = true;
    let getError = false;

    try {
        const fetchData = await fetch(url);

        if (!fetchData.ok) {
            getError = true;
            getLoading = false;
        }
        else {
            const data = await fetchData.json();

            if (dataHandler != null) {
                dataHandler(data);
            }

            getLoading = false;
        }
    } catch (error) {
        getLoading = false;
        getError = true;
    }

    return { getLoading, getError };
}

export const post = async (url: string, dataHandler: Function | null, params: {} | null, lang : string | null = null) => {

    let postLoading = true;
    let postError = false;

    if(lang == null) {
        lang = 'en';
    }

    const postOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'content-language' : lang
        },
        body: JSON.stringify(params),
    }

    try {
        const fetchData = await fetch(url, postOptions);

        if (!fetchData.ok) {
            postError = true;
            postLoading = false;
        }

        const data = await fetchData.json();

        if (dataHandler != null) {
            dataHandler(data);
        }

        postLoading = false;
    } catch (error) {
        postLoading = false;
        postError = true;
    }

    return { postLoading, postError };
}